import React, { useEffect, useState } from 'react';
import TrainingChart from '../components/TrainingChart';
import FPSBarChart from '../components/FPSBarChart';
import TrainingChartCompare from '../components/TrainingChartCompare';

const ExplorePage = () => {
  const [compareData, setCompareData] = useState([]);

  useEffect(() => {
    fetch('/compare_loss_data.json')
      .then((res) => res.json())
      .then((json) => setCompareData(json))
      .catch((err) => console.error('Failed to load:', err));
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">📊 Algorithm Comparison Dashboard</h1>

      <div className="grid grid-cols-2 gap-6">
        {/* 1. 📉 Training & Validation Loss */}
        <section className="bg-white p-4 rounded shadow h-[450px] overflow-hidden">
          <h2 className="text-xl font-semibold mb-2">📉 Training & Validation Loss Curves</h2>
          <TrainingChart compareMode={true} />
        </section>

        {/* 2. ⚡ Inference Speed (FPS) */}
        <section className="bg-white p-4 rounded shadow h-[450px] overflow-hidden">
          <h2 className="text-xl font-semibold mb-2">⚡ Inference Speed (FPS)</h2>
          <FPSBarChart />
        </section>

        {/* 3. ⚡ FPS Comparison by Algorithm */}
        <section className="bg-white p-4 rounded shadow h-[450px] overflow-hidden">
          <h2 className="text-xl font-semibold mb-2">⚡ FPS Comparison by Algorithm</h2>
          <p className="text-gray-700">
            This chart compares the frame-per-second inference speed across algorithms in identical parameter settings.
          </p>
          <FPSBarChart />
        </section>

        {/* 4. 🎞️ Output Videos */}
        <section className="bg-white p-4 rounded shadow h-[450px] overflow-hidden">
          <h2 className="text-xl font-semibold mb-2">🎞️ Output Videos (Side-by-side)</h2>
          <div className="grid grid-cols-2 gap-4">
            <video controls src="/placeholders/preview.mp4" className="w-full h-[320px] rounded shadow" />
            <video controls src="/placeholders/preview.mp4" className="w-full h-[320px] rounded shadow" />
          </div>
        </section>

        {/* 5. 📉 compare_loss_data.json Compare */}
        <section className="bg-white p-4 rounded shadow col-span-2 h-[450px] overflow-hidden">
          <h2 className="text-xl font-semibold mb-2">📉 compare_loss_data.json Compare</h2>
          <TrainingChartCompare data={compareData} />
        </section>
      </div>
    </div>
  );
};

export default ExplorePage;
